import "./Scrapping_status.css";
import "./statusBadge.css";
import { useState, useMemo, useEffect, useCallback, useRef } from "react";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
  getPaginationRowModel,
  getFilteredRowModel,
} from "@tanstack/react-table";
import { Full_traceback_log } from "./Full_traceback_log";
import axios from "axios";
import { Edit_modal } from "./Edit_modal";

export function Scrapping_status({ job_status }) {
  const [data, setData] = useState([]);
  console.log("data_from_db", data);
  console.log("job_status", job_status);
  console.log("type:", typeof data);
  const API_URL = process.env.REACT_APP_API_FAST;
  const REACT_APP_DIRECT = process.env.REACT_APP_DIRECT ;

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: Number.MAX_SAFE_INTEGER,
  });

  const [selectedTeamcode, setselectedTeamcode] = useState(null);
  const [teamA, setTeamA] = useState("");
  const [teamB, setTeamB] = useState("");
  const [normalizedTeamA, setNormalizedTeamA] = useState("");
  const [normalizedTeamB, setNormalizedTeamB] = useState("");

  const [globalFilter, setGlobalFilter] = useState("");
  const [showColumnSelector, setShowColumnSelector] = useState(false);

  const [columnVisibility, setColumnVisibility] = useState({});
  const [columnFilters, setColumnFilters] = useState([]);
  const [activeFilterColumn, setActiveFilterColumn] = useState(null);

  const delete_unmatch_handler = async (e) => {
    const currentState = resetOptions;
    console.log("selectedRows:", selectedRows);

    const selectedColumns = Object.keys(currentState).filter(
      (key) => currentState[key] === true
    );

    if (!selectedRows || selectedRows.length === 0) {
      alert("Please select at least one team");
      return;
    }

    const res = await fetch(`${API_URL}/api/delete_team_code`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        team_code: selectedRows,
      }),
    });

    if (!res.ok) return console.error("Request failed");

    const data = await res.json();
    console.log("Success:", data);
    showStatus(data.message, "success");
  };

  const [message, setMessage] = useState(null);
  const showStatus = (message, type = "success") => {
    setMessage({ message, type });

    setTimeout(() => {
      setMessage(null);
    }, 3500);
  };
  const [showModal, setShowModal] = useState(false);
  const [errorCode, setErrorCode] = useState("");

  const [resetOptions, setResetOptions] = useState({
    h2h_Status: false,
    h2h_Away_Status: false,
    h2h_Home_Status: false,
    ratio_result: false,
    compute_status: false,
  });

  useEffect(() => {
    console.log("resetOptions changedww:", resetOptions);
  }, [resetOptions]);

  // FETCH DATA
  useEffect(() => {
    fetch(`${REACT_APP_DIRECT}/table/scrapping_status`)
      .then((res) => res.json())
      .then((result) => setData(result || []))
      .catch((err) => console.error(err));
  }, []);

  // DEFAULT VISIBILITY
  useEffect(() => {
    setColumnVisibility({
      Team_code: true,
      filtered_status: true,
      h2h_Status: true,
      h2h_Away_Status: true,
      h2h_Home_Status: true,
      ratio_result: true,
      compute_status: true,
      team_a: false,
      team_b: false,
      href: false,
      id: false,
    });
  }, []);

  const handleTeamAClick = useCallback((row) => {
    setselectedTeamcode(row.original.Team_code);
    setTeamA(row.original.team_a || "");
    setTeamB(row.original.team_b || "");
  }, []);

  // CLEAN FILTER FUNCTION (FIX FOR match / no_match BUG)
  const safeFilterFn = (row, columnId, filterValue) => {
    if (!filterValue || filterValue.length === 0) return true;

    const cellValue = String(row.getValue(columnId)).trim().toLowerCase();

    const filters = filterValue.map((v) => String(v).trim().toLowerCase());

    return filters.includes(cellValue);
  };

  const mergedData = useMemo(() => {
    return data.map((row) => {
      const updatedRow = { ...row };

      for (const [, jobs] of Object.entries(job_status)) {
        const job = jobs[row.Team_code];
        if (!job) continue;

        switch (job.worker_name) {
          case "h_2_h_Que":
            updatedRow.h2h_Status = job.status;
            break;

          case "h_2_h_Away_Que":
            updatedRow.h2h_Away_Status = job.status;
            break;

          case "h_2_h_Home_Que":
            updatedRow.h2h_Home_Status = job.status;
            break;

          case "ratio_result_scrapping":
            updatedRow.ratio_result = job.status;
            break;
        }
      }

      return updatedRow;
    });
  }, [data, job_status]);

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  const handleEdit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setResetOptions({
      h2h_Status: false,
      h2h_Away_Status: false,
      h2h_Home_Status: false,
    });
    setModalOpen(true);
  };

  const submit_handler = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const currentState = resetOptions;
    console.log("selectedRows:", selectedRows);
    console.log("resetOptions:", resetOptions);
    const selectedColumns = Object.keys(currentState).filter(
      (key) => currentState[key] === true
    );
    if (selectedColumns.length === 0) {
      alert("Please select at least one column");
      return;
    }
    if (!selectedRows || selectedRows.length === 0) {
      alert("Please select at least one team");
      return;
    }

    console.log("readyy,", selectedColumns);
    console.log("code,", selectedRows);
    const res = await fetch(`${API_URL}/api/reset-team-status`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        team_code: selectedRows,
        columns: selectedColumns,
      }),
    });

    if (!res.ok) return console.error("Request failed");

    const data = await res.json();
    console.log("Success:", data);
    showStatus(data.message, "success");
  };
  const [selectMode, setSelectMode] = useState(false);
  const handleHeaderEdit = () => {
    setSelectMode((prev) => !prev);
    setSelectedRows([]);
  };
  function formatDuration(seconds) {
    if (seconds == null || seconds === "") return "";

    if (seconds < 60) {
      return `${Math.round(seconds)} sec`;
    }

    if (seconds < 3600) {
      return `${Math.round(seconds / 60)} min`;
    }

    return `${Math.round(seconds / 3600)} hrs`;
  }

  const columns = useMemo(
    () => [
      { accessorKey: "id", header: "ID", size: 50 },
      {
        accessorKey: "Team_code",
        header: () => (
          <div className="team-header">
            <span className="team-title">Team Code</span>

            <svg
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleHeaderEdit();
              }}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="team-edit-icon"
            >
              <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zm18-11.5a1.003 1.003 0 0 0 0-1.42l-1.34-1.34a1.003 1.003 0 0 0-1.42 0l-1.05 1.05 3.75 3.75L21 5.75z" />
            </svg>

            <div className="header-actions">
              <button
                onClick={(e) => handleEdit(e)}
                className="btn btn-edit btn-toggle-all"
              >
                Edit
              </button>

              <button
                onClick={(e) => submit_handler(e)}
                className="btn btn-submit"
              >
                Submit
              </button>
            </div>
          </div>
        ),

        cell: ({ getValue, row }) => {
          const code = row.original.Team_code;
          const isFirstVisibleRow = row.id === table.getRowModel().rows[0]?.id;

          return (
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {selectMode && isFirstVisibleRow && (
                <div className="select-all-wrapper">
                  <button
                    type="button"
                    className="btn btn-toggle-all  c_all"
                    onClick={() => {
                      const allCodes = table
                        .getPrePaginationRowModel()
                        .rows.map((r) => r.original.Team_code);

                      setSelectedRows((prev) =>
                        prev.length === allCodes.length ? [] : allCodes
                      );
                    }}
                  >
                    {selectedRows.length === table.getRowModel().rows.length
                      ? "None"
                      : "All"}
                  </button>
                </div>
              )}

              {/* Checkbox ONLY in select mode */}
              {selectMode && (
                <input
                  type="checkbox"
                  checked={selectedRows.includes(code)}
                  onChange={() => {
                    setSelectedRows((prev) =>
                      prev.includes(code)
                        ? prev.filter((c) => c !== code)
                        : [...prev, code]
                    );
                  }}
                />
              )}

              <span>{getValue()}</span>
            </div>
          );
        },
      },
      {
        accessorKey: "team_a",
        header: "Team A",
        filterFn: safeFilterFn,
        cell: ({ row }) => (
          <span
            onClick={() => handleTeamAClick(row)}
            style={{
              cursor: "pointer",
              color: "#0066ff",
              textDecoration: "underline",
            }}
          >
            {row.original.team_a}
          </span>
        ),
      },

      {
        accessorKey: "team_b",
        header: "Team B",
        filterFn: safeFilterFn,
      },

      {
        accessorKey: "href",
        header: "Href",
        cell: ({ row }) => {
          const href = row.original.url;

          return (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#0066ff",
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              {href}
            </a>
          );
        },
      },

      {
        accessorKey: "filtered_status",
        filterFn: safeFilterFn,
        header: () => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <span>Status</span>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.8}
              stroke="currentColor"
              className="team-delete-icon"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                delete_unmatch_handler();

                // delete logic here
                console.log("Delete Filter Status column");
              }}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 7h12M9 7V4h6v3m-7 4v6m4-6v6m4-6v6M5 7l1 13a1 1 0 001 1h10a1 1 0 001-1l1-13"
              />
            </svg>
          </div>
        ),
      },
      {
        accessorKey: "h2h_Status",
        header: "H-2-H",
        filterFn: safeFilterFn,
        cell: ({ row }) => {
          const h2h =
            typeof row.original.h2h_Status === "string"
              ? JSON.parse(row.original.h2h_Status)
              : row.original.h2h_Status || {};

          const state = (h2h?.state || "").toString().trim().toLowerCase();
          const duration = formatDuration(h2h?.duration || "");
          const hasError = Boolean(h2h?.error || h2h?.error_message);
          const errorMessage = String(h2h?.error_message ?? "");
          const errorCode = String(h2h?.error_code ?? "");

          const is_Completed = state.includes("completed");
          const is_Running = state.includes("running");
          const statusClass = hasError
            ? "error"
            : is_Completed
            ? "completed"
            : is_Running
            ? "running"
            : "pending";

          return (
            <div style={{ display: "flex", alignItems: "center" }}>
              <div className={`status-badge ${statusClass}`}>
                <span>
                  {hasError ? "⚠" : is_Completed ? "✓" : is_Running ? "⟳" : " "}
                </span>

                <span>{state || "-"}</span>

                {hasError && (
                  <span
                    className="status-error"
                    title={errorMessage}
                    onClick={() => {
                      setShowModal(true);
                      setErrorCode((h2h?.error_code || "").toString().trim());
                    }}
                  >
                    ▼
                  </span>
                )}

                {is_Completed && (
                  <span className="status-duration">⏱ {duration || "0s"}</span>
                )}
              </div>
            </div>
          );
        },
      },
      {
        accessorKey: "h2h_Away_Status",
        header: "H-2-H-A",
        filterFn: safeFilterFn,
        cell: ({ row }) => {
          const h2h_Awy =
            typeof row.original.h2h_Away_Status === "string"
              ? JSON.parse(row.original.h2h_Away_Status)
              : row.original.h2h_Away_Status;
          const state = (h2h_Awy?.state || "").toString().trim();
          const duration = formatDuration(h2h_Awy?.duration || "");
          const count_link = h2h_Awy?.count_link || "";
          const counting_current = h2h_Awy?.counting || "";
          const hasError = Boolean(h2h_Awy?.error || h2h_Awy?.error_message);
          const errorMessage = String(h2h_Awy?.error_message ?? "");
          const is_Completed = state.includes("completed");
          const is_Running = state.includes("running");
          const statusClass = hasError
            ? "error"
            : is_Completed
            ? "completed"
            : is_Running
            ? "running"
            : "pending";

          console.log("liking245", h2h_Awy);

          return (
            <>
              <div className={`status-badge ${statusClass} processing_layout`}>
                {/* Row 1 */}
                <div className="status-row">
                  <span className="status-icon">
                    {hasError
                      ? "⚠"
                      : is_Completed
                      ? "✓"
                      : is_Running
                      ? "⟳"
                      : "•"}
                  </span>

                  <span className="status-state">{state || "-"}</span>

                  {!hasError && counting_current && (
                    <span className="status-chip status-count">
                      {counting_current}
                    </span>
                  )}

                  {hasError && (
                    <span
                      className="status-error"
                      title={errorMessage}
                      onClick={() => {
                        setShowModal(true);
                        setErrorCode(
                          (h2h_Awy?.error_code || "").toString().trim()
                        );
                      }}
                    >
                      ▼
                    </span>
                  )}
                </div>

                {/* Row 2 */}
                {is_Completed && (
                  <div className="status-row status-meta-row">
                    <span className="status-chip status-duration">
                      ⏱ {duration || "0s"}
                    </span>

                    {!hasError && count_link && (
                      <a
                        href={count_link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="status-chip status-link"
                      >
                        🔗 Count
                      </a>
                    )}
                  </div>
                )}
              </div>
            </>
          );
        },
      },
      {
        accessorKey: "h2h_Home_Status",
        header: "H-2-H-H",
        filterFn: safeFilterFn,
        cell: ({ row }) => {
          const h2h_home =
            typeof row.original.h2h_Home_Status === "string"
              ? JSON.parse(row.original.h2h_Home_Status)
              : row.original.h2h_Home_Status;

          const state = (h2h_home?.state || "").toString().trim();
          const count_link = h2h_home?.count_link || "";
          const counting_current = h2h_home?.counting || "";
          const duration = formatDuration(h2h_home?.duration || "");
          const errorMessage = String(h2h_home?.error_message ?? "");
          const hasError = Boolean(h2h_home?.error || h2h_home?.error_message);

          const is_Completed = state.includes("completed");
          const is_Running = state.includes("running");
          const statusClass = hasError
            ? "error"
            : is_Completed
            ? "completed"
            : is_Running
            ? "running"
            : "pending";

          return (
            <>
              <div className={`status-badge ${statusClass} processing_layout`}>
                {/* Row 1 */}
                <div className="status-row">
                  <span className="status-icon">
                    {hasError
                      ? "⚠"
                      : is_Completed
                      ? "✓"
                      : is_Running
                      ? "⟳"
                      : "•"}
                  </span>

                  <span className="status-state">{state || "-"}</span>

                  {!hasError && counting_current && (
                    <span className="status-chip status-count">
                      {counting_current}
                    </span>
                  )}

                  {hasError && (
                    <span
                      className="status-error"
                      title={errorMessage}
                      onClick={() => {
                        setShowModal(true);
                        setErrorCode(
                          (h2h_home?.error_code || "").toString().trim()
                        );
                      }}
                    >
                      ▼
                    </span>
                  )}
                </div>

                {/* Row 2 */}
                {is_Completed && (
                  <div className="status-row status-meta-row">
                    <span className="status-chip status-duration">
                      ⏱ {duration || "0s"}
                    </span>

                    {!hasError && count_link && (
                      <a
                        href={count_link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="status-chip status-link"
                      >
                        🔗 Count
                      </a>
                    )}
                  </div>
                )}
              </div>
            </>
          );
        },
      },
      {
        accessorKey: "ratio_result",
        header: "R_R",
        filterFn: safeFilterFn,
        cell: ({ row }) => {
          const ratioResult =
            typeof row.original.ratio_result === "string"
              ? JSON.parse(row.original.ratio_result)
              : row.original.ratio_result;

          const state = (ratioResult?.state || "").toString().trim();
          const duration = formatDuration(ratioResult?.duration || "");

          // console.log("liking", ratioResult);

          const hasError = Boolean(
            ratioResult?.error || ratioResult?.error_message
          );

          const errorMessage = String(ratioResult?.error_message ?? "");

          const is_Completed = state.includes("completed");
          const is_Running = state.includes("running");
          const statusClass = hasError
            ? "error"
            : is_Completed
            ? "completed"
            : is_Running
            ? "running"
            : "pending";

          return (
            <div style={{ display: "flex", alignItems: "center" }}>
              <div className={`status-badge ${statusClass}`}>
                <span>
                  {hasError ? "⚠" : is_Completed ? "✓" : is_Running ? "⟳" : " "}
                </span>

                <span>{state || "-"}</span>

                {hasError && (
                  <span
                    className="status-error"
                    title={errorMessage}
                    onClick={() => {
                      setShowModal(true);
                      setErrorCode(
                        (ratioResult?.error_code || "").toString().trim()
                      );
                    }}
                  >
                    ▼
                  </span>
                )}

                {is_Completed && (
                  <span className="status-duration">⏱ {duration || "0s"}</span>
                )}
              </div>
            </div>
          );
        },
      },
      {
        accessorKey: "compute_status",
        header: "compute_status",
        filterFn: safeFilterFn,
        cell: ({ row }) => {
          const ComputeResult =
            typeof row.original.compute_status === "string"
              ? JSON.parse(row.original.compute_status)
              : row.original.compute_status;

          const state = (ComputeResult?.state || "").toString().trim();

          const hasError = Boolean(
            ComputeResult?.error_code || ComputeResult?.error_message
          );

          const errorMessage = String(ComputeResult?.error_message ?? "");

          const is_Completed = state.includes("completed");
          const is_Running = state.includes("running");
          const statusClass = hasError
            ? "error"
            : is_Completed
            ? "completed"
            : is_Running
            ? "running"
            : "pending";

          return (
            <div style={{ display: "flex", alignItems: "center" }}>
              <div className={`status-badge ${statusClass}`}>
                <span>
                  {hasError ? "⚠" : is_Completed ? "✓" : is_Running ? "⟳" : " "}
                </span>

                <span>{state || "-"}</span>

                {hasError && (
                  <span
                    className="status-error"
                    title={errorMessage}
                    onClick={() => {
                      setShowModal(true);
                      setErrorCode(
                        (ComputeResult?.error_code || "").toString().trim()
                      );
                    }}
                  >
                    ▼
                  </span>
                )}

                {is_Completed && (
                  <span className="status-duration">⏱ {"0" || "0s"}</span>
                )}
              </div>
            </div>
          );
        },
      },

      // end -----
    ],
    [handleTeamAClick, selectMode, selectedRows]
  );

  // TABLE
  const table = useReactTable({
    data: mergedData,
    columns,
    state: {
      columnVisibility,
      globalFilter,
      columnFilters,
      pagination,
    },
    onPaginationChange: setPagination,

    onColumnVisibilityChange: setColumnVisibility,
    onGlobalFilterChange: setGlobalFilter,
    onColumnFiltersChange: setColumnFilters,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
  });

  // UNIQUE VALUES FOR FILTER DROPDOWN
  const getUniqueValues = (columnId) => {
    return [...new Set(data.map((row) => row[columnId]).filter(Boolean))];
  };

  // TOGGLE FILTER VALUE
  const toggleFilterValue = (columnId, value) => {
    setColumnFilters((prev) => {
      const existing = prev.find((f) => f.id === columnId);

      if (!existing) {
        return [...prev, { id: columnId, value: [value] }];
      }

      const current = existing.value || [];

      const updated = current.includes(value)
        ? current.filter((v) => v !== value)
        : [...current, value];

      return prev.map((f) =>
        f.id === columnId ? { ...f, value: updated } : f
      );
    });
  };

  const submitResult = async () => {
    const normA = normalizedTeamA.trim();
    const normB = normalizedTeamB.trim();

    if (!normA && !normB) {
      alert("Enter at least one normalized team name.");
      return;
    }

    try {
      const res = await fetch(
        `${API_URL}/api/submit_updated_Normalization`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            teamcode: selectedTeamcode,
            raw_team_name: teamA,
            raw_team_nameB: teamB,
            NormalizedA: normalizedTeamA,
            NormalizedB: normalizedTeamB,
          }),
        }
      );

      const submission_result = await res.json();
      console.log("sub_result", submission_result);

      if (res.ok && submission_result.success) {
        setselectedTeamcode(null);
        setTeamA("");
        setTeamB("");
        setNormalizedTeamA("");
        setNormalizedTeamB("");

        setMessage("Normalization saved successfully");
        setMessageType("success");
      } else {
        setMessage(submission_result.error || "Failed to save");
        setMessageType("error");
      }
    } catch (error) {
      setMessage("Server connection failed");
      setMessageType("error");
      console.error(error);
    }

    setTimeout(() => {
      setMessage("");
    }, 3000);
  };
  return (
    <>
      {message && (
        <div className={`status_card ${message.type}`}>{message.message}</div>
      )}
      {/* filter&columns _button */}
      <div className="top-bar">
        {" "}
        <div className="global_search">
          <input
            placeholder="Search..."
            value={globalFilter}
            onChange={(e) => setGlobalFilter(e.target.value)}
          />
          {globalFilter && (
            <button
              className="clear-icon"
              onClick={() => setGlobalFilter("")}
              aria-label="Clear search"
            >
              ✕
            </button>
          )}
        </div>
        <div>
          {" "}
          <button onClick={() => setShowColumnSelector(!showColumnSelector)}>
            Columns ⚙️
          </button>
        </div>
      </div>
      {showColumnSelector && (
        <div className="column-selector">
          {table.getAllLeafColumns().map((col) => (
            <label key={col.id}>
              <input
                type="checkbox"
                checked={col.getIsVisible()}
                onChange={col.getToggleVisibilityHandler()}
              />
              {col.columnDef.header}
            </label>
          ))}
        </div>
      )}

      {/* TABLE */}
      <table className="data-table">
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <th key={header.id}>
                  <div>
                    {flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}

                    <button
                      onClick={() =>
                        setActiveFilterColumn(
                          activeFilterColumn === header.column.id
                            ? null
                            : header.column.id
                        )
                      }
                    >
                      🔽
                    </button>
                  </div>

                  {/* FILTER DROPDOWN */}
                  {activeFilterColumn === header.column.id && (
                    <div className="filter-dropdown">
                      {getUniqueValues(header.column.id).map((value) => (
                        <label key={value}>
                          <input
                            type="checkbox"
                            checked={(
                              columnFilters.find(
                                (f) => f.id === header.column.id
                              )?.value || []
                            ).includes(value)}
                            onChange={() =>
                              toggleFilterValue(header.column.id, value)
                            }
                          />
                          {value}
                        </label>
                      ))}
                    </div>
                  )}
                </th>
              ))}
            </tr>
          ))}
        </thead>

        <tbody>
          {table.getRowModel().rows.map((row) => (
            <tr key={row.id}>
              {row.getVisibleCells().map((cell) => (
                <td key={cell.id}>
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

      {/* PAGINATION */}
      <div className="table-pagination">
        {/* Page size */}
        <div className="page-size">
          <span>Show</span>

          <select
            value={table.getState().pagination.pageSize}
            onChange={(e) => {
              const value = e.target.value;

              const totalRows = table.getPrePaginationRowModel().rows.length;

              table.setPageSize(value === "all" ? totalRows : Number(value));
            }}
            className="page-select"
          >
            {[10, 20, 30, 50].map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}

            <option value="all">All</option>
          </select>
        </div>

        {/* Pagination controls */}
        <div className="pagination-controls">
          <button
            className="btn btn-nav"
            onClick={() => table.previousPage()}
            disabled={!table.getCanPreviousPage()}
          >
            ← Prev
          </button>

          <span className="page-info">
            Page {table.getState().pagination.pageIndex + 1} of{" "}
            {table.getPageCount()}
          </span>

          <button
            className="btn btn-nav"
            onClick={() => table.nextPage()}
            disabled={!table.getCanNextPage()}
          >
            Next →
          </button>
        </div>
      </div>

      {selectedTeamcode && (
        <div className="modal">
          <div className="modal_box">
            <h3>
              {teamA} vs {teamB}
            </h3>

            <input
              placeholder="Home_Team"
              value={normalizedTeamA}
              onChange={(e) => setNormalizedTeamA(e.target.value)}
            />

            <input
              placeholder="Away_Team"
              value={normalizedTeamB}
              onChange={(e) => setNormalizedTeamB(e.target.value)}
            />

            <button onClick={submitResult}>Submit</button>

            <button onClick={() => setselectedTeamcode(null)}>Cancel</button>
          </div>
        </div>
      )}
      {showModal && (
        <>
          <Full_traceback_log
            setShowModal={setShowModal}
            errorCode={errorCode}
          />
        </>
      )}

      {modalOpen && (
        <Edit_modal
          resetOptions={resetOptions}
          setResetOptions={setResetOptions}
          onClose={() => {
            setModalOpen(false);
          }}
        />
      )}
    </>
  );
}
